import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MarkdownComponent } from 'ngx-markdown';
import { AppRoutes } from '../../app.routes';
import { DocGroup, DocPage, DOC_GROUPS, DOC_PAGES } from './docs.manifest';

@Component({
    selector: 'app-docs',
    templateUrl: './docs.component.html',
    styleUrl: './docs.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule, MarkdownComponent]
})
export class DocsComponent {
  /** Route params; default to the first page when missing/unknown. */
  @Input() group?: string;
  @Input() page?: string;

  readonly groups: DocGroup[] = DOC_GROUPS;
  readonly docsHome = `/${AppRoutes.Docs}`;

  constructor(private router: Router) {}

  get currentSlug(): string {
    const slug = this.group && this.page ? `${this.group}/${this.page}` : '';
    return DOC_PAGES.some((p) => p.slug === slug) ? slug : DOC_PAGES[0].slug;
  }

  get currentPage(): DocPage {
    return DOC_PAGES.find((p) => p.slug === this.currentSlug) || DOC_PAGES[0];
  }

  get currentGroup(): DocGroup {
    return (
      this.groups.find((g) => g.pages.some((p) => p.slug === this.currentSlug)) || this.groups[0]
    );
  }

  get docSrc(): string {
    return `docs/${this.currentSlug}.md`;
  }

  docRoute(page: DocPage): string {
    return `/${AppRoutes.Docs}/${page.slug}`;
  }

  groupRoute(group: DocGroup): string {
    return this.docRoute(group.pages[0]);
  }

  /** Route internal doc links (e.g. `webhooks/managing`) through the SPA router. */
  handleContentClick(event: MouseEvent): void {
    const anchor = (event.target as HTMLElement).closest('a');
    if (!anchor) {
      return;
    }
    const href = anchor.getAttribute('href') || '';
    // Let external links, mailto, and in-page anchors behave normally.
    if (/^(https?:|mailto:|#|\/)/.test(href)) {
      return;
    }
    event.preventDefault();
    const segments = href.replace(/\.md$/, '').split('/').filter(Boolean);
    this.router.navigate([AppRoutes.Docs, ...segments]);
  }
}
